var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{staticClass:"rec-navbar",attrs:{"app":"","elevation":"0"}},[_c('img',{staticClass:"ebc-logo",attrs:{"alt":"logo","src":require('./assets/ebc-logo.svg'),"width":"120"}})]),_c('v-main',[_c('nav',{staticClass:"rec-separator"}),_c('div',{staticClass:"container"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }